import axios from 'util/axiosConfig';
import { getErrorMessage } from '../util/ErrorUtils';

export const getLockedVisitsAPI = async () => {
    return await axios.get(`/api/v1/admin/locked-visits`, {
        params: {
            // userId: userId
        }
    })
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false };
        });
}

export const unlockVisitAPI = async (reportId) => {
    return await axios.get(`/api/v1/unlock-visit`, {
        params: {
            reportId,
        }
    })
        .then(function (response) {
            if (response.status === 200) {
                return { success: true, response: response.data };
            } else {
                return { success: false, error: null };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        })
}

export const lockVisitAPI = async (reportId) => {
    return await axios.get(`/api/v1/lock-visit`, {
        params: {
            reportId
        }
    })
        .then(function (response) {
            if (response.status === 200) {
                return { success: true, response: response.data };
            } else {
                return { success: false, error: null };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        })
}